import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import App from './App'
import CPDashboard from './pages/CPDashboard'
import './styles/index.css'
import { initializeGTM } from './utils/gtm'

// Initialize Google Tag Manager (production only)
initializeGTM();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/cp_dashboard" element={<CPDashboard />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
) 